var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('box_1'),_c('box_2'),_c('box_3'),_c('box_4'),_c('box_5')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }